import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AuthService } from '@Core/services/auth.service';

@Component({
    standalone: false,
    selector: 'select-tenant',
    templateUrl: './select-tenant.component.html',
})
export class SelectTenantComponent implements OnInit {
    @Input() selectedTenant: { key: string; name: string };
    @Input() tenants: { key: string; name: string }[] = [];

    @Output() onTenantSelect: EventEmitter<{ key: string; name: string }> = new EventEmitter();
    @Output() onChangeUser: EventEmitter<any> = new EventEmitter();

    public selectedTenantKey: string = null;
    public tenant_invalid: boolean = false;

    constructor(private authService: AuthService) { }

    ngOnInit() {
        if (this.selectedTenant) {
            this.selectedTenantKey = this.selectedTenant.key;
        }
    }

    get sortedTenants(): { key: string; name: string }[] {
        if (!this.tenants) {
            return [];
        }
        return [...this.tenants].sort((a, b) => {
            const nameA = (a.name || a.key).toLowerCase();
            const nameB = (b.name || b.key).toLowerCase();
            return nameA.localeCompare(nameB);
        });
    }

    onTenantChange() {
        this.tenant_invalid = false;

        if (this.selectedTenantKey) {
            const foundTenant = this.tenants.find(t => t.key === this.selectedTenantKey);
            if (foundTenant) {
                this.selectedTenant = {
                    key: foundTenant.key,
                    name: foundTenant.name
                };
            } else {
                this.selectedTenant = null;
            }
        } else {
            this.selectedTenant = null;
        }
    }

    onSelectButtonClick() {
        if (!this.selectedTenant) {
            this.tenant_invalid = true;
            return;
        }

        this.onTenantSelect.emit(this.selectedTenant);
    }
};

